import { Helpers } from '../../../core/src/helpers';
import { formatGTMAction } from '../../../metrics/metrics-helpers';

export const getPriceProps = (priceData, options) => {
    if (!priceData) {
        return {};
    }
    const { salePriceSuffix, isFreeGift, msrp, priceProps } = options || {};
    const { gsPrice, oPrice, savedTag, privateDisclaimer: exclusiveLabel } = priceData || {};
    const discountAmount = Helpers.convertPriceToNumber(savedTag);
    const hasDiscount = discountAmount > 0;

    if (isFreeGift) {
        return {
            finalPrice: 'FREE',
        };
    }

    const oldPrice = hasDiscount ? Helpers.formatCurrency(gsPrice, undefined, true) : undefined;
    const saveLabel = hasDiscount ? `SAVE  ${Helpers.formatCurrency(discountAmount, undefined, true)}` : undefined;
    const subscriptionTermLabel = salePriceSuffix ? salePriceSuffix.trim() : undefined;

    return {
        oldPrice,
        finalPrice: Helpers.formatCurrency(oPrice, undefined, true),
        saveLabel,
        exclusiveLabel,
        msrp,
        saveLabelHighlighted: true,
        subscriptionTermLabel,
        ...(priceProps || {}),
    };
};

export const getPrimaryImage = (item, priceObj) => {
    if (!item) {
        return null;
    }
    const { fullImages = {} } = priceObj || {};
    const { xitem_prodThumbnail: thumbnail } = item;
    const hpServicesImg = fullImages[Object.keys(fullImages || {}).find(key => key.includes('Img_Center'))];

    return Helpers.decodeHtml(hpServicesImg) || thumbnail;
};

export const hasSubscription = (orderItem = []) => {
    return orderItem.filter(item => item.xitem_subscriptionFreqHeader).length > 0;
};

export const getQuantityGtmAction = (cartId, item, index) => {
    const { partNumber, quantity } = item || {};
    const decreaseAction = formatGTMAction(
        {
            category: 'removeFromCart',
            value: 'cart',
            id: `cart-${partNumber}`,
            cartId,
            quantity: 1,
            object: 'cartProducts',
        },
        true,
    );
    const increaseAction = formatGTMAction(
        {
            category: 'addToCart',
            value: 'cart',
            id: `cart-${partNumber}`,
            cartId,
            quantity: 1,
            object: 'cartProducts',
        },
        true,
    );

    return new Map([
        ['decreaseBtn', decreaseAction],
        ['increaseBtn', increaseAction],
    ]);
};

export const getRemoveGtmAction = (cartId, item, index) => {
    const { partNumber, quantity } = item || {};
    const removeAction = formatGTMAction({
        category: 'removeFromCart',
        value: 'cart',
        id: `cart-${partNumber}`,
        cartId,
        quantity: quantity * 1,
        object: 'cartProducts',
    });
    return removeAction;
};
